import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useBrandStore } from 'stores';

const LogoutRoute = () => {
  const { logout } = useAuth0();
  const { clearBrandStore } = useBrandStore();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome migration; the app is already working as expected with these dependency arrays
  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    clearBrandStore();
  }, []);

  return null;
};

export default LogoutRoute;
